import React, {useContext, useEffect, useState} from 'react';
import {Spinner} from 'react-bootstrap';
import {observer} from 'mobx-react-lite';
import {Context} from '../../index';
import Container from '../../components/ui/Container';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Seo from '../../components/ui/Seo';
import PostBody from '../../components/postBody/postBody';
import PaginationBlock from '../../components/Pagination/PaginationBlock';
import ErrorPage from '../ErrorPage/ErrorPage';
import {EXAMPLES_ROUTE} from '../../utils/const';
import styles from './News.module.css';

const News = observer(() => {
    const {posts, global} = useContext(Context);
    global.setIsAdminPage(false);
    const [isPostsLoaded, setIsPostsLoaded] = useState(false);
    const [pageNumber, setPageNumber] = useState(window.location.search.split('=')[1] ?? '');

    useEffect(() => {
        setIsPostsLoaded(false);
        posts.loadPosts(pageNumber).then(() => setIsPostsLoaded(true));
    }, [pageNumber, posts]);

    if (posts.error) {
        return <ErrorPage/>;
    }

    return (
        <Container className={styles.page}>
            <Seo
                title="Примеры работ — 4 Цвета"
                description="Примеры работ, готовая продукция и материалы полиграфической компании 4 Цвета."
            />
            <Breadcrumbs items={[{label: 'Примеры работ'}]}/>
            <header className={styles.header}>
                <p>Портфолио</p>
                <h1>Примеры работ</h1>
            </header>
            {isPostsLoaded ? (
                <>
                    <div className={styles.list}>
                        {posts.posts.map((post, index) => (
                            <article className={styles.card} key={post.id}>
                                <PostBody data={post} index={index} showText={false}/>
                            </article>
                        ))}
                    </div>
                    <div className={styles.pagination}>
                        <PaginationBlock
                            count={posts.pagination.count}
                            current={posts.pagination.current}
                            route={EXAMPLES_ROUTE}
                            setPageNumber={setPageNumber}
                        />
                    </div>
                </>
            ) : (
                <Spinner className="spinner" animation="grow"/>
            )}
        </Container>
    );
});

export default News;
